/* <buy-box>: kit tiles, option pills, stone picker, gallery, delivery estimate, wallets,
   includes list, add-on and sticky bar. */
(function () {
  'use strict';

  if (customElements.get('buy-box')) return;

  var A = window.Atelier;
  var S = A.strings;

  function el(tag, attrs, text) {
    var node = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { node.setAttribute(k, attrs[k]); });
    if (text != null) node.textContent = text;
    return node;
  }

  class BuyBox extends HTMLElement {
    connectedCallback() {
      this.products = JSON.parse(this.querySelector('[data-products]').textContent);
      this.mode = this.dataset.mode;
      this.tiles = Array.prototype.slice.call(this.querySelectorAll('[data-tile]'));
      this.form = this.querySelector('[data-buy-form]');
      this.variantInput = this.querySelector('[data-variant-input]');
      this.optionsEl = this.querySelector('[data-options]');
      this.stonesEl = this.querySelector('[data-stones]');
      this.sticky = this.querySelector('[data-sticky]');
      this.stones = [];
      this.pIndex = this.mode === 'products' ? parseInt(this.dataset.start, 10) || 0 : 0;
      // 'optiontiles': one product whose option at this index (e.g. Kit: For one / For two) drives the tiles.
      this.tileOption = parseInt(this.dataset.tileOption, 10);

      var product = this.products[this.pIndex];
      var initial = this.findVariant(product, function (v) { return v.id === product.selected; }) || product.variants[0];
      this.variant = initial;

      this.bindTiles();
      this.bindForm();
      this.bindGalleries();
      this.bindStones();
      this.bindIncludes();
      this.bindUpsell();
      this.bindSticky();

      var delivery = this.querySelector('[data-delivery]');
      if (delivery) delivery.textContent = A.deliveryWindow(parseInt(this.dataset.leadMin, 10), parseInt(this.dataset.leadMax, 10));

      this.renderOptions();
      this.update(false);

      this.addEventListener('shopify:block:select', function (event) {
        var tile = event.target.querySelector && event.target.querySelector('[data-tile]');
        if (tile) this.selectTile(this.tiles.indexOf(tile));
      }.bind(this));
    }

    disconnectedCallback() {
      if (this.stickyObserver) this.stickyObserver.disconnect();
      window.removeEventListener('scroll', this.onStickyScroll);
    }

    /* ------------------------------------------------------------ data */

    findVariant(product, test) {
      for (var i = 0; i < product.variants.length; i++) if (test(product.variants[i])) return product.variants[i];
      return null;
    }

    /** Best variant of `product` matching the current option values (e.g. keep the firing method when switching kits). */
    matchVariant(product, options) {
      var exact = this.findVariant(product, function (v) {
        return v.options.every(function (o, i) { return o === options[i]; });
      });
      if (exact) return exact;
      var byFirst = this.findVariant(product, function (v) {
        return options.some(function (o) { return v.options.indexOf(o) !== -1; }) && v.available;
      });
      return byFirst || this.findVariant(product, function (v) { return v.available; }) || product.variants[0];
    }

    activeTile() {
      if (this.mode === 'products') return this.tiles[this.pIndex];
      if (this.mode === 'variants') {
        var id = this.variant.id;
        return this.tiles.filter(function (t) { return Number(t.dataset.variant) === id; })[0];
      }
      if (this.mode === 'optiontiles') {
        var value = this.variant.options[this.tileOption];
        return this.tiles.filter(function (t) { return t.dataset.value === value; })[0];
      }
      return null;
    }

    /** Index of the selected tile (the product index in 'products' mode). */
    tileIndex() {
      var tile = this.activeTile();
      return tile ? this.tiles.indexOf(tile) : this.pIndex;
    }

    /** The variant a tile would select, keeping the other current options. */
    tileVariant(tile, i) {
      var v = this.variant;
      if (this.mode === 'products') return this.matchVariant(this.products[i], v.options);
      var product = this.products[this.pIndex];
      if (this.mode === 'optiontiles') {
        var wanted = v.options.slice();
        wanted[this.tileOption] = tile.dataset.value;
        return this.matchVariant(product, wanted);
      }
      return this.findVariant(product, function (x) { return x.id === Number(tile.dataset.variant); });
    }

    makers() {
      var tile = this.activeTile();
      return tile ? parseInt(tile.dataset.makers, 10) || 1 : 1;
    }

    /* ------------------------------------------------------------ tiles */

    bindTiles() {
      var self = this;
      this.tiles.forEach(function (tile, i) {
        tile.addEventListener('click', function () { self.selectTile(i); });
        tile.addEventListener('keydown', function (event) {
          var step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
          if (!step) return;
          event.preventDefault();
          var next = (i + step + self.tiles.length) % self.tiles.length;
          self.selectTile(next);
          self.tiles[next].focus();
        });
      });
    }

    selectTile(i) {
      if (i < 0) return;
      if (this.mode === 'products') {
        if (i === this.pIndex) return;
        this.pIndex = i;
        this.variant = this.matchVariant(this.products[i], this.variant.options);
        this.renderOptions();
      } else if (this.mode === 'variants') {
        var id = Number(this.tiles[i].dataset.variant);
        this.variant = this.findVariant(this.products[0], function (v) { return v.id === id; }) || this.variant;
      } else if (this.mode === 'optiontiles') {
        if (this.tiles[i] === this.activeTile()) return;
        this.variant = this.tileVariant(this.tiles[i], i);
      }
      this.update(true);
    }

    /* ------------------------------------------------------------ options */

    renderOptions() {
      var product = this.products[this.pIndex];
      this.optionsEl.innerHTML = '';
      if (product.defaultOnly || this.mode === 'variants') return;
      var self = this;
      product.options.forEach(function (option, oi) {
        if (self.mode === 'optiontiles' && oi === self.tileOption) return; // shown as tiles
        var group = el('div', { class: 'buy-box__field' });
        var head = el('div', { class: 'buy-box__field-head' });
        var labelId = self.id + '-opt-' + oi;
        head.appendChild(el('p', { class: 'buy-box__label', id: labelId }, option.name));
        group.appendChild(head);
        var pills = el('div', { class: 'pills', role: 'radiogroup', 'aria-labelledby': labelId });
        option.values.forEach(function (value) {
          var pill = el('button', { type: 'button', class: 'pill', role: 'radio', 'data-option': oi, 'data-value': value }, value);
          pill.addEventListener('click', function () {
            var wanted = self.variant.options.slice();
            wanted[oi] = value;
            self.variant = self.matchVariant(product, wanted);
            self.update(true);
          });
          pills.appendChild(pill);
        });
        group.appendChild(pills);
        self.optionsEl.appendChild(group);
      });
    }

    syncOptions() {
      var product = this.products[this.pIndex];
      var current = this.variant;
      this.optionsEl.querySelectorAll('.pill').forEach(function (pill) {
        var oi = parseInt(pill.dataset.option, 10);
        var value = pill.dataset.value;
        var on = current.options[oi] === value;
        pill.setAttribute('aria-checked', String(on));
        // Mark values that would lead to a sold-out combination.
        var probe = current.options.slice();
        probe[oi] = value;
        var match = product.variants.filter(function (v) {
          return v.options.every(function (o, i) { return o === probe[i]; });
        })[0];
        pill.classList.toggle('is-unavailable', !match || !match.available);
      });
    }

    /* ------------------------------------------------------------ render */

    update(userAction) {
      var product = this.products[this.pIndex];
      var v = this.variant;
      var self = this;

      this.variantInput.value = v.id;

      // Tiles. A multi-maker tile saves against buying that many single-maker kits.
      var baseIndex = -1;
      this.tiles.forEach(function (tile, i) {
        if (baseIndex < 0 && (parseInt(tile.dataset.makers, 10) || 1) === 1) baseIndex = i;
      });
      var baseVariant = baseIndex >= 0 ? this.tileVariant(this.tiles[baseIndex], baseIndex) : null;
      this.tiles.forEach(function (tile, i) {
        var on = tile === self.activeTile();
        tile.setAttribute('aria-checked', String(on));
        tile.tabIndex = on ? 0 : -1;
        var tv = self.tileVariant(tile, i);
        if (!tv) return;
        var makers = parseInt(tile.dataset.makers, 10) || 1;
        tile.querySelector('[data-tile-price]').textContent = A.formatMoneyShort(tv.price);
        var save = tile.querySelector('[data-tile-save]');
        var saving = 0;
        if (makers > 1 && baseVariant) saving = baseVariant.price * makers - tv.price;
        else if (tv.compare > tv.price) saving = tv.compare - tv.price;
        if (saving > 0) {
          save.textContent = S.save.replace('[amount]', A.formatMoneyShort(saving));
          save.hidden = false;
        } else {
          save.hidden = true;
        }
        var unit = tile.querySelector('[data-tile-unit]');
        if (unit && makers > 1) {
          unit.textContent = S.perMaker.replace('[amount]', A.formatMoney(Math.round(tv.price / makers)));
          unit.hidden = false;
        }
        tile.classList.toggle('is-unavailable', !tv.available);
      });

      this.syncOptions();

      // CTA
      var label = v.available ? null : S.soldOut;
      this.querySelectorAll('[data-cta-price]').forEach(function (node) { node.textContent = A.formatMoneyShort(v.price); });
      this.querySelectorAll('[data-cta]').forEach(function (btn) {
        btn.disabled = !v.available;
        var l = btn.querySelector('[data-cta-label]');
        if (!l.dataset.default) l.dataset.default = l.textContent;
        l.textContent = label || l.dataset.default;
      });
      var stickyCta = this.querySelector('[data-sticky-cta]');
      if (stickyCta) stickyCta.disabled = !v.available;

      // Galleries: show the active product's and its photo for the selected option.
      // Jump straight there on load or when a kit's gallery first appears; glide on option changes.
      this.querySelectorAll('[data-gallery]').forEach(function (g) {
        g.hidden = parseInt(g.dataset.gallery, 10) !== self.pIndex;
      });
      var galleryChanged = this.shownGallery !== this.pIndex;
      this.shownGallery = this.pIndex;
      this.showVariantMedia(product, v, userAction && !galleryChanged);

      // Wallet buttons: show the active product's and point it at the variant.
      this.querySelectorAll('[data-wallet]').forEach(function (w) {
        var on = parseInt(w.dataset.wallet, 10) === self.pIndex;
        w.hidden = !on;
        if (on) {
          var input = w.querySelector('[data-wallet-id]');
          if (input) input.value = v.id;
        }
      });

      // What's inside
      var tile = this.activeTile();
      var insideName = this.querySelector('[data-inside-name]');
      if (insideName) insideName.textContent = tile ? tile.dataset.name : product.title;
      var ti = this.tileIndex();
      this.querySelectorAll('[data-include-for]').forEach(function (item) {
        var f = item.dataset.includeFor;
        var forTile = f === 'all' || parseInt(f, 10) === ti;
        // Items tied to an option value (e.g. a firing method) only show when the variant has it.
        var opt = item.dataset.includeOption;
        var forOption = !opt || v.options.indexOf(opt) !== -1;
        item.hidden = !(forTile && forOption);
      });
      var qty = this.querySelector('[data-includes-qty]');
      if (qty) {
        var tpl = this.querySelector('[data-includes-count="' + ti + '"]');
        qty.textContent = tile && tile.dataset.includes != null ? tile.dataset.includes : tpl ? tpl.innerHTML.trim() : '';
      }
      this.querySelectorAll('[data-row-value]').forEach(function (cell) {
        var second = cell.dataset.rowAlt;
        cell.textContent = ti === 1 && second ? second : cell.dataset.rowValue;
      });

      // Stones
      this.renderStonePicks();

      // Sticky bar
      this.renderSticky();

      // URL on product pages
      if (userAction && this.dataset.updateUrl === 'true' && window.history.replaceState) {
        var url = new URL(product.url, window.location.origin);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }

      var error = this.querySelector('[data-error]');
      if (error) error.hidden = true;
    }

    /* ------------------------------------------------------------ gallery */

    bindGalleries() {
      this.querySelectorAll('[data-gallery]').forEach(function (gallery) {
        var track = gallery.querySelector('[data-gallery-track]');
        var slides = Array.prototype.slice.call(track.children);
        var dots = gallery.querySelectorAll('.gallery__dot');
        var thumbs = gallery.querySelectorAll('[data-thumb]');
        var current = 0;
        function setActive(i) {
          current = i;
          dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
          thumbs.forEach(function (t, j) {
            t.classList.toggle('is-on', j === i);
            t.setAttribute('aria-current', String(j === i));
          });
        }
        var ticking = false;
        track.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
            if (i !== current) setActive(Math.max(0, Math.min(slides.length - 1, i)));
          });
        }, { passive: true });
        function go(i, instant) {
          i = (i + slides.length) % slides.length;
          track.scrollTo({ left: i * track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
          setActive(i);
        }
        thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function () { go(i); }); });
        var prev = gallery.querySelector('[data-gallery-prev]');
        var next = gallery.querySelector('[data-gallery-next]');
        if (prev) prev.addEventListener('click', function () { go(current - 1); });
        if (next) next.addEventListener('click', function () { go(current + 1); });
        track.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') { event.preventDefault(); go(current - 1); }
          if (event.key === 'ArrowRight') { event.preventDefault(); go(current + 1); }
        });
        gallery.mediaIds = slides.map(function (s) { return Number(s.dataset.mediaId); });
        gallery.goToMedia = function (id, instant) {
          var index = gallery.mediaIds.indexOf(id);
          if (index >= 0 && (index !== current || instant)) go(index, instant);
        };
      });
    }

    /**
     * Move the active gallery to the selected variant's image. A variant with no image of its own
     * gets the first photo that isn't another option's, so it never keeps showing the wrong option.
     */
    showVariantMedia(product, variant, smooth) {
      var gallery = this.querySelector('[data-gallery="' + this.pIndex + '"]');
      if (!gallery || !gallery.goToMedia) return;
      var id = variant.media;
      if (!id) {
        var others = product.variants
          .filter(function (x) { return x.media && x.media !== variant.media; })
          .map(function (x) { return x.media; });
        if (!others.length) return; // This product doesn't use per-option photos.
        id = gallery.mediaIds.filter(function (m) { return others.indexOf(m) === -1; })[0];
      }
      if (id) gallery.goToMedia(id, !smooth);
    }

    currentImage() {
      var gallery = this.querySelector('[data-gallery="' + this.pIndex + '"]');
      if (!gallery) return null;
      var track = gallery.querySelector('[data-gallery-track]');
      var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
      var slide = track.children[i] || track.children[0];
      return slide ? slide.querySelector('img') : null;
    }

    /* ------------------------------------------------------------ stones */

    bindStones() {
      if (!this.stonesEl) return;
      this.dialog = this.stonesEl.querySelector('[data-stone-dialog]');
      this.options = Array.prototype.slice.call(this.stonesEl.querySelectorAll('[data-stone]'));
      this.picksEl = this.stonesEl.querySelector('[data-stone-picks]');
      var self = this;
      // Default: give each maker a different stone set.
      this.stones = this.options.map(function (o) { return o.dataset.stone; });
      this.stonesEl.addEventListener('click', function (event) {
        var open = event.target.closest('[data-stone-open]');
        if (open) self.openStones(parseInt(open.dataset.stoneOpen, 10) || 0);
      });
      this.options.forEach(function (option) {
        option.addEventListener('click', function () {
          self.options.forEach(function (o) { o.setAttribute('aria-checked', String(o === option)); });
          self.pendingStone = option.dataset.stone;
        });
      });
      this.dialog.querySelector('[data-stone-use]').addEventListener('click', function () {
        if (self.pendingStone) self.stones[self.pickIndex] = self.pendingStone;
        if (self.pickIndex + 1 < self.makers()) {
          self.openStones(self.pickIndex + 1);
        } else {
          self.dialog.close();
        }
        self.renderStonePicks();
      });
      this.dialog.querySelector('[data-stone-close]').addEventListener('click', function () { self.dialog.close(); });
      this.dialog.addEventListener('click', function (event) {
        if (event.target === self.dialog) self.dialog.close();
      });
      this.dialog.addEventListener('close', function () { A.lockScroll(false); });
    }

    openStones(index) {
      this.pickIndex = index;
      var chosen = this.stones[index];
      this.pendingStone = chosen;
      this.options.forEach(function (o) { o.setAttribute('aria-checked', String(o.dataset.stone === chosen)); });
      var step = this.dialog.querySelector('[data-stone-step]');
      var makers = this.makers();
      step.textContent = makers > 1 ? S.stoneStep.replace('[index]', index + 1).replace('[count]', makers) : '';
      if (!this.dialog.open) {
        this.dialog.showModal();
        A.lockScroll(true);
      }
    }

    renderStonePicks() {
      if (!this.picksEl || !this.options.length) return;
      var self = this;
      var makers = this.makers();
      var property = this.stonesEl.dataset.property;
      this.picksEl.innerHTML = '';
      var props = this.querySelector('[data-properties]');
      props.innerHTML = '';
      for (var i = 0; i < makers; i++) {
        var name = this.stones[i % this.stones.length];
        var option = this.options.filter(function (o) { return o.dataset.stone === name; })[0];
        var btn = el('button', {
          type: 'button',
          class: 'stone-pick',
          'data-stone-open': i,
          'aria-haspopup': 'dialog',
          'aria-label': (makers > 1 ? property + ' ' + (i + 1) + ': ' : '') + name + '. ' + S.change
        });
        var dot = el('span', { class: 'stone-dot', 'aria-hidden': 'true' });
        if (option) {
          dot.style.setProperty('--stone', option.dataset.color);
          if (option.dataset.image) dot.style.backgroundImage = 'url("' + option.dataset.image + '")';
        }
        btn.appendChild(dot);
        btn.appendChild(el('span', { 'aria-hidden': 'true' }, name));
        this.picksEl.appendChild(btn);
        var key = makers > 1 ? property + ' ' + (i + 1) : property;
        props.appendChild(el('input', { type: 'hidden', name: 'properties[' + key + ']', value: name }));
      }
      this.picksEl.dataset.n = makers;
    }

    /* ------------------------------------------------------------ includes, upsell */

    bindIncludes() {
      var toggle = this.querySelector('[data-includes-toggle]');
      var media = this.querySelector('[data-includes-media]');
      if (!toggle) return;
      if (!media) {
        toggle.setAttribute('aria-disabled', 'true');
        return;
      }
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        media.hidden = !open;
      });
    }

    bindUpsell() {
      var upsell = this.querySelector('[data-upsell]');
      if (!upsell) return;
      var select = upsell.querySelector('[data-upsell-select]');
      if (!select) return;
      var pct = parseInt(upsell.dataset.discount, 10) || 0;
      var idInput = upsell.querySelector('[data-upsell-id]');
      var prices = upsell.querySelector('[data-upsell-prices]');
      select.addEventListener('change', function () {
        var option = select.selectedOptions[0];
        var price = parseInt(option.dataset.price, 10);
        idInput.value = select.value;
        var sup = prices.querySelector('sup');
        prices.innerHTML = '';
        if (pct > 0) {
          prices.appendChild(el('b', null, A.formatMoney(Math.round((price * (100 - pct)) / 100))));
          prices.appendChild(document.createTextNode(' '));
          prices.appendChild(el('s', null, A.formatMoney(price)));
          if (sup) prices.appendChild(sup);
        } else {
          prices.appendChild(el('b', null, A.formatMoney(price)));
        }
      });
    }

    /* ------------------------------------------------------------ sticky bar */

    bindSticky() {
      if (!this.sticky) return;
      var self = this;
      var segs = this.sticky.querySelector('[data-sticky-segs]');
      if (segs) {
        this.tiles.forEach(function (tile, i) {
          var seg = el('button', { type: 'button', class: 'buy-sticky__seg', 'aria-pressed': 'false' }, tile.dataset.name);
          seg.addEventListener('click', function () { self.selectTile(i); });
          segs.appendChild(seg);
        });
      }
      this.cta = this.querySelector('[data-cta-wrap]');
      this.footer = document.querySelector('.site-footer');
      this.onStickyScroll = function () {
        if (self.stickyTicking) return;
        self.stickyTicking = true;
        requestAnimationFrame(function () {
          self.stickyTicking = false;
          var past = self.cta.getBoundingClientRect().bottom < 0;
          var footerIn = self.footer && self.footer.getBoundingClientRect().top < window.innerHeight;
          self.toggleSticky(past && !footerIn);
        });
      };
      window.addEventListener('scroll', this.onStickyScroll, { passive: true });
    }

    toggleSticky(on) {
      if (!this.sticky || this.sticky.classList.contains('is-on') === on) return;
      this.sticky.classList.toggle('is-on', on);
      this.sticky.setAttribute('aria-hidden', String(!on));
      if (on) this.sticky.removeAttribute('inert');
      else this.sticky.setAttribute('inert', '');
      document.body.classList.toggle('has-buy-sticky', on);
    }

    renderSticky() {
      if (!this.sticky) return;
      var product = this.products[this.pIndex];
      var v = this.variant;
      var tile = this.activeTile();
      var parts = [];
      if (tile) parts.push(tile.dataset.name);
      if (!product.defaultOnly && this.mode !== 'variants') {
        var tileOption = this.mode === 'optiontiles' ? this.tileOption : -1;
        parts.push(v.options.filter(function (o, i) { return i !== tileOption; }).join(' / '));
      }
      if (this.stonesEl && this.options && this.options.length) {
        var picked = [];
        for (var i = 0; i < this.makers(); i++) picked.push(this.stones[i % this.stones.length]);
        parts.push(picked.join(' + '));
      }
      var makers = this.makers();
      if (makers > 1) parts.push(S.perMaker.replace('[amount]', A.formatMoney(Math.round(v.price / makers))));
      this.sticky.querySelector('[data-sticky-sub]').textContent = parts.join(' · ');
      var art = this.sticky.querySelector('[data-sticky-art]');
      var src = v.image || product.image;
      art.innerHTML = '';
      if (src) art.appendChild(el('img', { src: src, alt: '', width: 48, height: 48, loading: 'lazy' }));
      var segs = this.sticky.querySelectorAll('.buy-sticky__seg');
      var activeTile = this.activeTile();
      var tiles = this.tiles;
      segs.forEach(function (seg, i) { seg.setAttribute('aria-pressed', String(tiles[i] === activeTile)); });
    }

    /* ------------------------------------------------------------ submit */

    bindForm() {
      var self = this;
      this.form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!self.variant.available) return;
        var formData = new FormData(self.form);
        var item = { id: self.variant.id, quantity: 1 };
        var properties = {};
        formData.forEach(function (value, key) {
          var match = key.match(/^properties\[(.+)\]$/);
          if (match) properties[match[1]] = value;
        });
        if (Object.keys(properties).length) item.properties = properties;
        var buttons = self.querySelectorAll('[data-cta], [data-sticky-cta]');
        buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
        var image = self.currentImage();
        A.cart
          .add([item])
          .then(function () { return A.flyToCart(image); })
          .then(function () { A.cart.open(); })
          .catch(function (error) {
            var box = self.querySelector('[data-error]');
            if (box) {
              box.textContent = error.message;
              box.hidden = false;
            } else {
              A.toast(error.message);
            }
          })
          .finally(function () {
            buttons.forEach(function (b) { b.removeAttribute('aria-busy'); });
          });
      });
    }
  }

  customElements.define('buy-box', BuyBox);
})();
